<template>
  <div v-if="reply_text" class="reviews-list__reply">
    <button class="reviews-list__reply-link"
            v-text="!isReplyShow ? $t('reviews.reply.show') : $t('reviews.reply.hide')"
            @click="showReplyHandler"
    />
    <div class="reviews-list__reply-content"
         v-show="isReplyShow"
    >
      <div class="reviews-list__reply-content-head">
        <avatar :name="expertData.name" :photo="expertData.avatar" />
        <div class="expert-name" v-text="expertData.name"/>
        <button-icon tag="span" class="expert-label">
          <template #before>
            <svg-inline tag="span">
              <icon icon="flag" color="#8600EF" />
            </svg-inline>
          </template>
          <span v-text="$t('reviews.reply.expertLabel')" />
        </button-icon>
      </div>
      <div class="reviews-list__reply-content-text" v-text="reply_text"/>
      <button class="reviews-list__reply-link"
              v-text="!isReplyShow ? $t('reviews.reply.show') : $t('reviews.reply.hide')"
              @click="showReplyHandler"
      />
    </div>
  </div>
</template>

<script>
import Avatar from "@/components/ui-kit/avatar/index.vue";
import ButtonIcon from "@/components/ui-kit/button-icon/index.vue";
import Icon from "@/components/icons/index.vue";
import SvgInline from "@/components/ui-kit/svg-inline/index.vue";

export default {
  components: {
    Avatar,
    ButtonIcon,
    Icon,
    SvgInline,
  },
  props: {
    reviews: {
      type: Array,
      required: true,
    },
    expertData: {
      type: Object,
      required: true,
    },
    reply_text: {
      type: String,
    },
  },
  data() {
    return {
      isReplyShow: false,
    };
  },
  methods: {
    showReplyHandler() {
      this.isReplyShow = !this.isReplyShow;
    },
  },
}
</script>
<style lang="scss" scoped>
.reviews-list {

  &__reply {
    padding: 20px;
    background: rgba(122, 21, 184, 0.06);
    border-radius: 16px;
    margin-top: 20px;

    &-link {
      color: #828296;
      text-decoration: underline;
      border: none;
      background: transparent;
      cursor: pointer;
      font-weight: 600;
    }

    &-content {

      &-head {
        height: 32px;
        margin-top: 16px;
        display: flex;
        align-items: center;
        font-weight: 600;
        font-size: 14px;

        .avatar {
          height: 32px;
          width: 32px;
        }

        .expert-name {
          color: #000;
          margin: 0 8px;
        }

        .expert-label {
          font-weight: 600;
          font-size: 14px;
          color: #8600EF;

          .svg-inline {
            width: 17px;
            margin-right: 3px;

            svg {
              fill: #8600EF !important;
              stroke: #8600EF !important;

              path {
                fill: #8600EF !important;
                stroke: #8600EF !important;
              }
            }
          }
        }
      }

      &-text {
        margin-top: 14px;
      }

      button {
        margin-top: 20px;
      }
    }
  }
}
</style>
